import { DataDocument, tagsTemplateDirectoryId } from '@fillip/api';

export const TemplateTagH1: DataDocument = {
  id: 'tag-h1',
  parentId: tagsTemplateDirectoryId,
  info: {
    title: 'Heading 1',
    icon: 'h1',
    isProtected: true,
  },
  element: {
    type: 'element.text',
    textFormat: 'h1',
    textContent: ':$text',
  },
  class: {
    class: ':`${$containerClasses}`',
    elementClass: ':`${$elementClasses}`',
  },
  tag: {
    tag: 'tag',
  },
  tagDefinition: {
    tag: 'h1',
    title: 'Heading 1',
    category: 'content',
    icon: 'h1',
    editor: 'h1',
  },
  interfaceDefinition: {
    title: '',
    inheritFrom: 'baseContent',
    props: [
      {
        title: 'Container Classes',
        key: 'containerClasses',
        type: 'string',
        defaultValue:
          ":`${$$contentTagClasses} ${$$headlineClasses} mb-6 text-xl md:text-2xl ${$containerClasses || properties?.containerClasses?.value || ''}`",
      },
      {
        title: 'Element Classes',
        key: 'elementClasses',
        type: 'string',
        defaultValue:
          ":`font-bold ${$elementClasses || properties?.elementClasses?.value || ''}`",
      },
    ],
  },
};
